import type { ReactNode } from 'react'

import styled from 'styled-components'

import type { helpers } from 'styles'

import { transparentStyling } from './Transparent'

type Props = {
	label: ReactNode
	fullWidth?: boolean
	link?: boolean
	slim?: boolean
	type?: keyof Omit<typeof helpers.color, 'status' | 'input' | 'button'>
}

export const TransparentNative = styled.a.attrs<Props>(({ label }) => ({
	children: label,
}))<Props>`
	${transparentStyling};
`
